import React, { createContext, useState, useEffect } from 'react';

interface ScryfallStatusContextType {
  isApiDown: boolean;
  setApiDown: (down: boolean) => void;
  lastFailureTime: number | null;
}

const ScryfallStatusContext = createContext<ScryfallStatusContextType | undefined>(undefined);

export const ScryfallStatusProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isApiDown, setIsApiDown] = useState(false);
  const [lastFailureTime, setLastFailureTime] = useState<number | null>(null);

  const setApiDown = (down: boolean) => {
    setIsApiDown(down);
    if (down) {
      setLastFailureTime(Date.now());
    } else {
      setLastFailureTime(null);
    }
  };

  // Reset API status after 5 minutes of no failures
  useEffect(() => {
    if (lastFailureTime && isApiDown) {
      const timer = setTimeout(() => {
        setIsApiDown(false);
        setLastFailureTime(null);
      }, 5 * 60 * 1000); // 5 minutes

      return () => clearTimeout(timer);
    }
  }, [lastFailureTime, isApiDown]);

  return (
    <ScryfallStatusContext.Provider value={{ isApiDown, setApiDown, lastFailureTime }}>
      {children}
    </ScryfallStatusContext.Provider>
  );
};

export { ScryfallStatusContext };